document.addEventListener("turbo:load", function () {
  console.log("Dark mode script loaded");

  // Función para verificar si es hora de modo oscuro (entre 8 PM y 6 AM)
  function isDarkModeTime() {
    const hour = new Date().getHours();
    return hour >= 20 || hour < 6;
  }

  // Función para obtener la preferencia del usuario
  function getUserPreference() {
    return localStorage.getItem('darkMode');
  }

  // Función para establecer el modo oscuro
  function setDarkMode(enabled) {
    console.log("Setting dark mode:", enabled);
    const html = document.documentElement;
    const body = document.body;
    
    if (enabled) {
      html.classList.add('dark');
      body.classList.add('dark');
      body.style.backgroundColor = '#111827'; // dark:bg-gray-900
      body.style.color = '#ffffff'; // dark:text-white
      console.log("Added dark class. Current classes:", html.classList.toString());
    } else {
      html.classList.remove('dark');
      body.classList.remove('dark');
      body.style.backgroundColor = '#ffffff'; // bg-white
      body.style.color = '#111827'; // text-gray-900
      console.log("Removed dark class. Current classes:", html.classList.toString());
    }
    
    localStorage.setItem('darkMode', enabled);
    
    // Verificar si el cambio se aplicó correctamente
    setTimeout(() => {
      const isDark = html.classList.contains('dark');
      console.log("Verification - Is dark mode active?", isDark);
    }, 100);
  }

  // Función para inicializar el modo oscuro
  function initializeDarkMode() {
    const userPreference = getUserPreference();
    console.log("Initializing dark mode, user preference:", userPreference);
    
    if (userPreference === null) {
      // Si no hay preferencia guardada, usar el modo automático
      setDarkMode(isDarkModeTime());
    } else {
      // Usar la preferencia guardada del usuario
      setDarkMode(userPreference === 'true');
    }
  }

  // Función para actualizar el modo oscuro según la hora
  function updateDarkModeByTime() {
    if (getUserPreference() === null) {
      setDarkMode(isDarkModeTime());
    }
  }

  // Inicializar el modo oscuro
  initializeDarkMode();

  // Actualizar cada hora
  setInterval(updateDarkModeByTime, 3600000);

  // Agregar botón de cambio manual
  function setupDarkModeToggle() {
    console.log("Setting up dark mode toggle");
    const darkModeToggles = document.querySelectorAll('#darkModeToggle');
    console.log("Found dark mode toggles:", darkModeToggles.length);
    
    darkModeToggles.forEach(toggle => {
      console.log("Adding click listener to toggle");
      toggle.addEventListener('click', function(e) {
        console.log("Toggle clicked");
        e.preventDefault();
        e.stopPropagation();
        
        const html = document.documentElement;
        const isDark = html.classList.contains('dark');
        console.log("Current dark mode state:", isDark);
        
        // Forzar el cambio de modo
        setDarkMode(!isDark);
        
        // Verificar el cambio
        setTimeout(() => {
          console.log("After toggle - Is dark mode active?", html.classList.contains('dark'));
        }, 100);
      });
    });
  }

  // Configurar el toggle inmediatamente
  setupDarkModeToggle();

  // También configurar cuando el DOM cambie (por si el botón se carga dinámicamente)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setupDarkModeToggle();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 